import { useTheme } from "next-themes";
import { Moon, Sun, LayoutGrid, Library, LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Brand } from "./Brand";
import { MuteToggle } from "./MuteToggle";
import { BasketButton } from "./BasketDrawer";
import { useAuth } from "../context/AuthContext";
import { StepRail } from "./StepRail";
import { AccountMenu } from "./AccountMenu";

const AccountControl = ({ onOpenGallery }) => {
  const { isAuthed, openAuth } = useAuth();
  if (!isAuthed) {
    return (
      <Button data-testid="nav-signin-btn" onClick={openAuth} className="rounded-full gap-2 font-bold">
        <LogIn className="h-4 w-4" />
        <span className="hidden sm:inline">Sign in</span>
      </Button>
    );
  }
  return <AccountMenu testid="nav-account-btn" onOpenGallery={onOpenGallery} />;
};

export const Navbar = ({ step, onStepClick, galleryCount, onOpenGallery }) => {
  const { theme, setTheme } = useTheme();
  const { isAuthed } = useAuth();
  return (
    <header className="sticky top-0 z-40 border-b border-border/70 bg-background/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto h-20 px-3 sm:px-8 lg:px-12 flex items-center justify-between gap-2 sm:gap-4">
        <button
          data-testid="app-header-logo"
          onClick={() => onStepClick(1)}
          className="flex items-center gap-3 group min-w-0"
        >
          <Brand hideTextBelowSm={isAuthed} />
        </button>

        <StepRail step={step} onStepClick={onStepClick} className="hidden lg:flex" />

        <div className="flex items-center gap-1 sm:gap-2 shrink-0">
          <Link to="/library" data-testid="nav-library-link">
            <Button variant="ghost" size="icon" className="rounded-full sm:size-auto sm:w-auto sm:px-4 gap-2">
              <Library className="h-4 w-4" />
              <span className="hidden sm:inline">Library</span>
            </Button>
          </Link>
          {isAuthed && (
            <Button
              data-testid="nav-gallery-btn"
              variant="outline"
              className="rounded-full gap-2"
              onClick={onOpenGallery}
            >
              <LayoutGrid className="h-4 w-4" />
              <span className="hidden sm:inline">My Ducks</span>
              {galleryCount > 0 && (
                <span className="grid place-items-center h-5 min-w-5 px-1 rounded-full bg-accent text-accent-foreground text-[11px] font-bold">
                  {galleryCount}
                </span>
              )}
            </Button>
          )}
          <BasketButton />
          <MuteToggle />
          <Button
            variant="ghost"
            size="icon"
            className="rounded-full"
            data-testid="theme-toggle-btn"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          >
            {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </Button>
          <AccountControl onOpenGallery={onOpenGallery} />
        </div>
      </div>
      <div className="lg:hidden max-w-7xl mx-auto px-3 sm:px-8 pb-2">
        <StepRail step={step} onStepClick={onStepClick} id="step-rail-mobile" />
      </div>
    </header>
  );
};
